import React from 'react';
import Navbar from '../../components/Navbar';
import PatientEdit from '../../components/Patient/PatientEdit';
import './PatientEditPage.css';

const PatientEditPage = () => {
  return (
    <div className="patient-edit-page">
      <Navbar />
      <div className="edit-container">
        <PatientEdit />
      </div>
    </div>
  );
};

export default PatientEditPage;
